import { Pipe, PipeTransform, Inject, LOCALE_ID, InjectionToken } from '@angular/core';

export const BIF_LANG_RESOURCES = new InjectionToken("BIF_LANG_RESOURCES");

@Pipe({ name: 'aifLocale' })
export class AifLocalePipe implements PipeTransform {
    private readonly defaultLang: string = "zh-CHS";
    private langCode: string;
    private lang: {};
    private resources;
    constructor(
        @Inject(LOCALE_ID) localeId: string,
        @Inject(BIF_LANG_RESOURCES) resources: any,
    ) {
        this.langCode = localeId || this.defaultLang;
        this.resources = resources || {};
        this.lang = resources[this.langCode] || resources[this.defaultLang] || {};
    }
    transform(name: string): any {
        return this.lang[name] || name;
    }

    instant(name: string): any {
        return this.transform(name);
    }
}

